<template>
  <div>
    <v-dialog :value="value" persistent scrollable max-width="1200px">
      <v-card>
        <v-layout class="px-2" style="width: 100%" row justify-space-between>
          <v-layout row wrap class="mb-0 mt-3 ml-3">
            <h5 class="mr-2" style="width: max-content">
              Select the template topic you want to add.
            </h5>
            <v-flex class="mt-1 default-input" style="width: 170px">
              <v-text-field
                v-model="searchText"
                style="width: 170px"
                outline
                name="name"
                hide-details
                density="compact"
                placeholder="Find a conversation."
              ></v-text-field>
            </v-flex>
          </v-layout>
          <div>
            <v-btn fab small flat @click="$emit('input', false)">
              <v-icon>close</v-icon>
            </v-btn>
          </div>
        </v-layout>
        <v-divider class="my-2"></v-divider>
        <div style="max-height: 70vh; overflow: auto">
          <div class="px-2">
            <v-layout row wrap style="margin: 0">
              <v-flex
                v-for="(item, index) in selectedIntentTemplateData"
                :key="`intent-template-item-${index}`"
                class="px-2 py-3"
                xs12
                sm6
                md4
              >
                <IntentTemplateItem :item="item" @created="createdIntent" />
              </v-flex>
            </v-layout>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import IntentTemplateItem from './IntentTemplateItem'
import { mapGetters } from 'vuex'
export default {
  components: { IntentTemplateItem },
  props: ['value'],
  data() {
    return {
      isVisible: false,
      searchText: ''
    }
  },
  computed: {
    ...mapGetters({
      intentTemplateData: 'intentTemplateData'
    }),
    selectedIntentTemplateData() {
      const vm = this
      if (vm.searchText) {
        const tempData = vm.intentTemplateData.filter(
          (x) => x.name && x.name.toLowerCase().match(vm.searchText.toLowerCase())
        )
        return tempData
      } else {
        return vm.intentTemplateData
      }
    }
  },
  methods: {
    createdIntent() {
      this.$emit('input', false)
      this.$emit('createdIntent')
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/intent/IntentTemplate/IntentTemplateList.vue